import React from 'react'
import { connect } from "react-redux";
import { Card, Menu, Icon } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'
import MarkPayedItem from 'components/invoices/MarkPayedItem'
import SendEmailItem from 'components/invoices/SendEmailItem'
import PdfItem from 'components/invoices/PdfItem'
import ActionsMenu from "./ActionsMenu";
import PeppolItem from "./PeppolItem";

class InvoicesListItem extends React.Component {

  render () {
    const {invoice, dossier, view} = this.props

    let CardContentWithLink
    if (invoice.concept) {
      CardContentWithLink = (props) => <Card.Content as={NavLink} to={Routes.invoice_path({ id: invoice.id, _options: true })}> {props.children} </Card.Content>
    }
    else {
      CardContentWithLink = (props) => <Card.Content as='a' href={Routes.invoice_path({ id: invoice.id, _options: true, format: 'pdf' })}  target="_blank" rel="noopener noreferrer"> {props.children} </Card.Content>
    }

    return (
      <Card key={invoice.id} color={invoice.proposed ? "orange" : null } className={invoice.proposed ? "opaque" : null}>
        <CardContentWithLink>
          <Card.Header>
            {`${invoice.formattedIdentification}: ${invoice.patient?.firstName} ${invoice.patient?.lastName}`}
          </Card.Header>
          {invoice.creditNoteReference && <Card.Content content={I18n.t('components.invoice.credit_note_for', {invoice_number: invoice.creditNoteReference} )}/> }
          <Card.Meta>
            { invoice.invoiceDate ? I18n.t('components.invoices_list_item.invoice_date', { date: I18n.l("date.formats.default",invoice.invoiceDate) })  : null }
          </Card.Meta>
          <Card.Meta>
            { invoice.paid ?  I18n.t('components.invoices_list_item.paid') : null }
          </Card.Meta>
          {
            (invoice.emailCommunications || []).map ( (communication) =>
              {
                if ( communication.createdAt) {
                  return (<Card.Meta>{I18n.t('components.invoices_list_item.sent_at', { date: I18n.l("date.formats.default",communication.createdAt)})}</Card.Meta>)
                } else {
                  return (<Card.Meta>{I18n.t('components.invoices_list_item.sent')}</Card.Meta>)
                }
              }
            )
          }
        </CardContentWithLink>
        {view === 'admin' &&

         <Card.Content extra>
           {dossier.responsibles?.map(resp => <div key={`responsible-${resp.id}`}><Icon style={{color: resp.color }} name="user"/> {resp.name}</div>)}
         </Card.Content>
        }
        <Card.Content extra style={{padding: 0}}>
          <Menu compact icon borderless secondary size='large'>
            <PdfItem invoice={invoice}/>
            <MarkPayedItem invoice={invoice}/>
            <SendEmailItem invoice={invoice}/>
            <PeppolItem invoice={invoice}/>
            {!invoice.concept && <ActionsMenu invoice={invoice}/>}
          </Menu>
        </Card.Content>

    </Card>)
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dossier: ownProps.invoice.dossier,
    view: state.view
  }
}

export default connect(mapStateToProps)(InvoicesListItem);
